const settings = {
  passwordCriteria: {
    minLength: process.env.APP_PASSWORD_MIN_LENGTH || 8,
    minUppercase: process.env.APP_PASSWORD_MIN_UPPERCASE || 1,
    minSpecialCharacters: process.env.APP_PASSWORD_MIN_SPECIAL_CHARACTERS || 1,
    minNumbers: process.env.APP_PASSWORD_MIN_NUMBERS || 1,
    validator: process.env.APP_PASSWORD_CRITERIA || '',
  },
  maxImageFileSize: process.env.APP_MAX_IMAGE_FILE_SIZE || 20, // 20MB
  acceptedImageFileTypes: process.env.APP_ACCEPTED_IMAGE_FILE_TYPES || 'image/jpeg,image/png,image/jpg',
  acceptedFileTypes:
    process.env.APP_ACCEPTED_FILE_TYPES ||
    'application/pdf,application/msword,application/vnd.openxmlformats-officedocument.wordprocessingml.document,csv',
  maxFileSize: process.env.APP_MAX_FILE_SIZE || 20, // 20MB
  currency: {
    label: process.env.APP_CURRENCY_LABEL || 'AUD',
    locale: process.env.APP_CURRENCY_LOCALE || 'en-AU',
    symbol: process.env.APP_CURRENCY_SYMBOL || '$',
  },
  dateFormat: process.env.APP_DATE_FORMAT || 'DD/MM/YYYY',
  defaultPerPage: process.env.APP_DEFAULT_PER_PAGE || 10,
} as Record<string, any>;

export default settings;
